import { montaUrlFiltroPaginacaoUsuario } from "../utils/DataUtils";
import api from "./api";

const endpoint = "/usuario_";
const PAGE_SIZE = 5;

export const createUsuario = async (usuario) => {
    try {
        const response = await api.post(endpoint, usuario, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            const { status, data } = error.response;
            if (status === 409) {
                return data;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }
}

export const getUsuariosFiltrados = async (usuarioFilter, page) => {
    try {
        const response = await api.get(montaUrlFiltroPaginacaoUsuario(endpoint, usuarioFilter, page, PAGE_SIZE));
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
}

export const getUsuarios = async (page = 0) => {
    try {
        const response = await api.get(endpoint + "?page=" + page + "&size=" + PAGE_SIZE);
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
}

export const getUsuarioById = async (idUsuario) => {
    try {
        const response = await api.get(endpoint + `/${idUsuario}`);
        return response.data;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export const updateUsuario = async (usuario) => {
    try {
        const response = await api.put(endpoint + `/${usuario.idUsuario}`, usuario, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            const { status, data } = error.response;
            if (status === 409) {
                return data;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }
}

export const getUsuarioByDepartamentoEmpresaList = async (listaDeptoEmpresa) => {
    try {
        const response = await api.post(endpoint + "/byDepartamentoEmpresaList", [listaDeptoEmpresa], {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
}


